import React, { useState } from "react";
import EnterPasswordModal from "../Modals/EnterPasswordModal";
import axios from "axios";
import { useSelector } from "react-redux";
import { path } from "../../path";

const DeleteContestButton = ({ contest }) => {
  const [modal, setModal] = useState(false);
  const { token } = useSelector((state) => state.AuthReducer);

  const handleDeleteContest = async () => {
    try {
      deleteFunction(contest?._id)
      .then(() => {
        setTimeout(() => {
          alert("Deleted successfully");
          window.location.reload();
        }, 200);
      })
      .catch((error) => {
        console.error("Error deleting contest:", error);
        alert("Failed to delete the item. Please try again.");
      });
    } catch (error) {
      console.log("Error in deleting contest", error);
    }
  };

  const deleteFunction = async (id) => {
    await axios.delete(`${path}/contest/deleteContestById/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
  };

  return (
    <div className=" text-black">
      {modal && (
        <EnterPasswordModal
          onSuccess={handleDeleteContest}
          setModal={setModal}
          title={`Enter password to delete ${contest.responses.sections[2].fields[0].response} contest`}
        />
      )}
      <div
        className="rounded-lg text-red-700 cursor-pointer opacity-30"
        onClick={() => setModal(true)}>
        Delete
      </div>
    </div>
  );
};

export default DeleteContestButton;
